import { StaticImageData } from 'next/image';

import fintechImg from './assets/fintech.png';
import advisorImg from './assets/bz-advisor.png';
import ringTheBellImg from './assets/ringthebell.png';
import techTrendsImg from './assets/bz-tech-trends.png';
import proTradersUpdateImg from './assets/pro-traders-update.png';
import researchDailyImg from './assets/research-daily.png';

interface BaseNewsletter {
  description: string;
  frequency: string;
  logo: StaticImageData;
  name: string;
}

export interface BeehiivNewsletter extends BaseNewsletter {
  type: 'beehiiv';
  publicationId: string;
}

export interface IterableNewsletter extends BaseNewsletter {
  type: 'iterable';
  workflowId: number;
}

export type Newsletter = BeehiivNewsletter | IterableNewsletter;

export const newsletters: Newsletter[] = [
  {
    type: 'beehiiv',
    description:
      'A newsletter built for market enthusiasts by market enthusiasts. Top stories, top movers, and trade ideas delivered to your inbox every weekday before the market opens.',
    frequency: 'Daily Monday - Friday',
    logo: ringTheBellImg,
    name: 'Ring the Bell',
    publicationId: 'pub_c03f46e3-b180-439f-8cf4-103cbf2ac567',
  },
  {
    type: 'beehiiv',
    description:
      "Where fintech, crypto, and the future of finance collide. Delivered every day at 12 pm ET, it's a perfect lunch read packed with quick bites for industry enthusiasts.",
    frequency: 'Daily Monday - Friday',
    logo: fintechImg,
    name: 'Future Finance',
    publicationId: 'pub_6adcc974-5582-4d9a-aaa1-ec9219ddc7b6',
  },
  // {
  //   type: 'beehiiv',
  //   description:
  //     'A must-read daily briefing for cannabis investors, operators, and enthusiasts. Join our list of industry veterans to jump start your morning.',
  //   frequency: 'Daily',
  //   logo: cannabisImg,
  //   name: 'Cannabis Insider',
  //   publicationId: 'pub_3b79c3b8-6d60-45fd-957c-4b815b7b7f77',
  // },
  // {
  //   type: 'beehiiv',
  //   description:
  //     "Looking to learn more about the world of REITs and real assets? Subscribe to Benzinga's weekly real estate newsletter where we highlight movers and losers, upgrades and downgrades, and top stories shaking the trillion dollar industry.",
  //   frequency: 'Weekly',
  //   logo: realEstateImg,
  //   name: 'Real Estate',
  //   publicationId: 'pub_bede23bb-0f71-43c1-911c-feda9088ad30',
  // },
  {
    type: 'beehiiv',
    description:
      'Financial advisors, get the most important talking points for clients, timely reminders, and market context to make you the smartest and most proactive advisor in the room - straight in your inbox every Sunday!',
    frequency: 'Weekly',
    logo: advisorImg,
    name: 'Benzinga Advisor',
    publicationId: 'pub_6aa83b63-4682-47eb-9cb0-5d4d4e238f2d',
  },
  {
    type: 'beehiiv',
    description:
      'Stay ahead of the curve with the inside scoop on AI, the hottest gadgets and mind-blowing tech trends every week, straight in your inbox every Tuesday.',
    frequency: 'Weekly',
    logo: techTrendsImg,
    name: 'Tech Trends',
    publicationId: 'pub_3d4df704-a7e2-4fea-9c81-c7293e2a6bf6',
  },
  {
    type: 'iterable',
    description:
      "Pro Traders Update delivers actionable trade ideas and expert tips — powered by Benzinga Pro's real-time tools and data.",
    frequency: 'Weekly',
    logo: proTradersUpdateImg,
    name: 'Pro Traders Update',
    workflowId: 925127,
  },
  {
    type: 'iterable',
    description:
      'Your daily edge in the market — expert trade ideas, investing strategies, and research from Benzinga analysts you can trust.',
    frequency: 'Daily',
    logo: researchDailyImg,
    name: 'Research Daily',
    workflowId: 925128,
  },
];
